import useTranslation from 'next-translate/useTranslation'
import { BlackButton } from '@/components/atoms/button'
import { Flex } from '@/components/atoms/Grid'
import { FixedWidthModal } from '@/components/organisms/modal'
import FormInput from '@/components/molecules/form/formInput'
import FormElement from '@/components/molecules/form/formElement'
import { useEffect, useCallback, useState, FC } from 'react'
import { baseValidator, emailValidator } from '@/core/validationUtils'

type SharePopupProps = {
  onDidTapClose: () => void
  onSubmit: (email: string) => void
}

const SharePopup: FC<SharePopupProps> = ({ onDidTapClose, onSubmit }) => {
  const { t } = useTranslation('common')
  const [email, setEmail] = useState<string>()
  const [error, setError] = useState<string>(null)
  const [showValidation, setShowValidation] = useState<boolean>(false)

  const validate = useCallback((): boolean => {
    if (!baseValidator(email)) {
      setError(t('Wishlist.Form.emptyEmailErrorPlaceholder'))
      return false
    }

    if (!emailValidator(email)) {
      setError(t('Wishlist.Form.notValidEmailErrorPlaceholder'))
      return false
    }

    setError(null)
    return true
  }, [email])

  useEffect(() => {
    validate()
  }, [email])

  const onEmailChange = (name, value) => {
    setEmail(value)
  }

  const onClick = () => {
    setShowValidation(true)
    if (validate()) {
      onSubmit(email)
    }
  }

  return (
    <FixedWidthModal
      onDidTapClose={onDidTapClose}
      title={t('Wishlist.shareByEmail')}
    >
      <Flex flexDirection="column" width="100%">
        <FormElement
          label={t('Wishlist.emailShareLabel')}
          showValidation={showValidation}
          isValid={error === null}
        >
          <FormInput
            name="email"
            value={email}
            placeholder={t('Wishlist.emailShareLPlaceholder')}
            onChange={onEmailChange}
            isError={showValidation && error !== null}
            adjustPlaceholderPosition
            errorPlaceholder={error}
          />
        </FormElement>
        <BlackButton
          title={t('Wishlist.emailButtonShare')}
          onClick={onClick}
          mt={24}
        />
      </Flex>
    </FixedWidthModal>
  )
}

export default SharePopup
